namespace Areas {
    "use strict";

    export function addEditingButtons(e: any, buttonOptions: Array<string>) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        const editButtonsBuilder = new EditButtonsBuilder(grid, e.toolbarOptions);
        editButtonsBuilder.addButtons(buttonOptions);
    } 

    export function addEditBatchButton(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;
        const editBatchButtonConfiguration = new EditBatchButtonConfiguration(e.toolbarOptions);
        editBatchButtonConfiguration.configureBatchEditButtons();
    }
    
}